import Vue from "vue";

import { withTenant, noTenant, authHeader } from "./AuthHeader";
import { MEDICAL_INSURENCE_PARTICULAR } from "../store/booking/constants";
import { env } from "../config/env";

const apiUrl = env.CLINIC_API_URL + "/agendamento-online";

class BookingService {
  findHorarios(
    tenant,
    uf,
    data,
    profissional,
    convenioMedico,
    especialidade,
    telemedicina
  ) {
    let headers = noTenant();
    if (tenant) {
      headers = withTenant(tenant);
    }

    convenioMedico = convenioMedico
      ? convenioMedico
      : MEDICAL_INSURENCE_PARTICULAR.codigo;

    return Vue.prototype.$axios.get(apiUrl, {
      params: {
        uf,
        data,
        profissional,
        convenioMedico,
        especialidade,
        telemedicina
      },
      headers
    });
  }

  findHorariosByProfessional(
    tenant,
    data,
    agendamentoTelemedicina,
    profissional,
    tempoAtendimento
  ) {
    return Vue.prototype.$axios.get(apiUrl + "/horarios", {
      params: {
        data,
        agendamentoTelemedicina,
        profissional,
        tempoAtendimento
      },
      headers: withTenant(tenant)
    });
  }

  saveAgendamento(tenant, payload) {
    return Vue.prototype.$axios.post(apiUrl, payload, {
      headers: {
        ...authHeader(),
        ...withTenant(tenant)
      }
    });
  }
}

export default new BookingService();
